import i18n from '@/i18n';

const chartExportsConfigs = [
  { type: 'export-png', icon: 'icon-manage-import', text: i18n.t('download-in', { format: '.PNG' }) },
  { type: 'export-jpeg', icon: 'icon-manage-import', text: i18n.t('download-in', { format: '.JPEG' }) },
  { type: 'export-pdf', icon: 'icon-manage-import', text: i18n.t('download-in', { format: '.PDF' }) },
  { type: 'export-svg', icon: 'icon-manage-import', text: i18n.t('download-in', { format: '.SVG' }) },
  { type: 'divider' },
  { type: 'print', icon: 'icon-print', text: i18n.t('print-chart') },
];

const domainOptions = [
  {
    description: i18n.t('all-subdomains-and-all-pages'),
    name: '*.domain/*',
    question: 'https://support.keyword.com/en/articles/3347467-adding-editing-keywords',
    value: false,
  },
  {
    description: i18n.t('exact-url'),
    name: 'URL',
    question: 'https://support.keyword.com/en/articles/3347467-adding-editing-keywords',
    value: true,
  },
];

export { chartExportsConfigs, domainOptions };
